import { Footer } from './Footer/index.js';
import { FooterContacts } from './FooterContacts/index.js';
import { FooterList } from './FooterList/index.js';

const FooterComponent = {
  Footer,
  List: FooterList,
  Contacts: FooterContacts
};

export { FooterComponent };
//# sourceMappingURL=index.js.map
